'use client';

import SettingConfig from '@module/config/setting';
import { getCountryNames } from '@module/helpers/chat/formatCountryNamesByLocale';
import useChatMessageStore from '@module/stores/useChatMessageStore';
import type { ChatBlockCountryMessage } from '@module/types/centrifuge/public-message/ChatBlockCountryMessageTypes';
import { useEffect, useRef } from 'react';
interface Props {
  item: ChatBlockCountryMessage;
}

/**
 * ChatBlockCountry 메시지 컴포넌트
 * 이전 차단 목록과 현재 차단 목록을 비교하여 차단/해제된 국가를 구분하여 표시
 */
export default function ChatBlockCountryChat({
  item
}: Props) {
  // 현재 차단 목록,
  const currentBlockedLocales = item.data.message.blockedLocales;
  const preBlockedLocales = useChatMessageStore(state => state.preBlockedLocales);
  // 컴포넌트 초기 렌더링될 때의 preBlockedLocales 를 유지하기 위해 ref 관리
  const preBlockedLocalesRef = useRef(preBlockedLocales);

  // 새로 차단된 국가
  const newlyBlockedLocales = currentBlockedLocales.filter(locale => !preBlockedLocalesRef.current.includes(locale));

  // 해제된 국가
  const unblockedLocales = preBlockedLocalesRef.current.filter(locale_0 => !currentBlockedLocales.includes(locale_0));
  const blockedLocalesString = getCountryNames(newlyBlockedLocales, SettingConfig.LANG);
  const unblockedLocalesString = getCountryNames(unblockedLocales, SettingConfig.LANG);
  useEffect(() => {
    // 렌더링 완료 후 preBlockedLocales 갱신
    const {
      blockedLocales
    } = item.data.message;
    useChatMessageStore.getState().setPreBlockedLocales(blockedLocales);
  }, []);
  return <>
      {newlyBlockedLocales.length > 0 && <div className='mb-[3px] whitespace-pre-wrap text-cht_al_co'>
          <div>{`관리자에 의해 글로벌 시청자간 ${blockedLocalesString}의 채팅보기가 금지되었습니다.`}</div>
        </div>}
      {unblockedLocales.length > 0 && <div className='mb-[3px] whitespace-pre-wrap text-cht_al_co'>
          <div>{`관리자에 의해 글로벌 시청자간 ${unblockedLocalesString}의 채팅보기가 허용되었습니다.`}</div>
        </div>}
    </>;
}